module.exports = function() {
	return new Worker(__webpack_public_path__ + "7cb886ff82c1d32af7e9.fieldborders.wrkr.js");
};